import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import FAQ from "./pages/FAQ";
import TermsAndConditions from "./pages/TermsAndConditions";
import ProjectPage from "./pages/ProjectPage";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import Disclaimer from "./pages/Disclaimer";
import MoreDetails from "./pages/MoreDetails";
import { Toaster } from "react-hot-toast";
import ProjectKrishi2 from "./pages/ProjectKrishi2";
import KrishiVriddhi2Details from "./pages/KrishiVriddhi2Details";
import ScrollToTop from "./ScrollToTop";
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-YZ4N6JQL99", {
        page_path: location.pathname,
      });
    }
  }, [location]);
};

function App() {
  usePageTracking();
  // useScrollToTop();

  return (
    <Box sx={{ height: "100vh", overflowY: "scroll" }}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/refund-policy" element={<Refund />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/krishi-vriddhi" element={<MoreDetails />} />

        <Route path="/project" element={<ProjectPage />} />
        <Route path="/krishi-vriddhi-2" element={<KrishiVriddhi2Details />} />
      </Routes>

      <Toaster position="top-center" />
    </Box>
  );
}

export default App;
